module.exports = __webpack_public_path__ + "img/05010019.2364bc0a.jpg";